import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth';
import { Note, Spinner } from '../components/ui';

export default function Login() {
  const { signIn, provisioned, ephemeralSessionSecret } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(username.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gate">
      <form className="gate-card" onSubmit={submit}>
        <div className="gate-head">
          <div className="wordmark">
            stocks<b>·</b>ai
          </div>
          <p>Groq AI against pattern matching against both, traded on live prices in GBP.</p>
        </div>

        <div className="gate-body">
          {!provisioned && (
            <Note tone="warn" title="No operator provisioned">
              Set <code>AUTH_PASSWORD</code> in <code>.env</code> and restart the server.
            </Note>
          )}

          {ephemeralSessionSecret && (
            <Note tone="warn" title="Ephemeral session key">
              <code>JWT_SECRET</code> is unset or too short, so sessions will not survive a restart.
              Generate one with <code>openssl rand -hex 32</code>.
            </Note>
          )}

          {error && <Note tone="error">{error}</Note>}

          <div className="field">
            <label htmlFor="username">Operator</label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="field">
            <label htmlFor="password">Passphrase</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          <button className="key key-primary" type="submit" disabled={busy || !provisioned}>
            {busy ? <Spinner label="authenticating" /> : 'enter desk'}
          </button>

          <div className="mini" style={{ textAlign: 'center' }}>
            single operator · simulated fills · not investment advice
          </div>
        </div>
      </form>
    </div>
  );
}
